/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Legend_TitleInputs */

const en_pol_legend_title = /** @type {(inputs: Pol_Legend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the colours mean`)
};

const id_pol_legend_title = /** @type {(inputs: Pol_Legend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arti warna`)
};

/**
* | output |
* | --- |
* | "What the colours mean" |
*
* @param {Pol_Legend_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_legend_title = /** @type {((inputs?: Pol_Legend_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Legend_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_legend_title(inputs)
	return en_pol_legend_title(inputs)
});